<template>
  <div
    id="app"
    class="flex flex-col"
  >
    <BlockHeader />
    <transition
      name="fade"
      mode="out-in"
    >
      <RouterView class="flex-grow flex flex-col" />
    </transition>
    <BlockCookies />
  </div>
</template>

<script>
import { BlockHeader, BlockCookies } from '@c/Block';

export default {
  name: 'App',

  components: {
    BlockHeader,
    BlockCookies,
  },
};

</script>

<style src="@assets/css/index.css" />

<style scoped>
/* purgecss start ignore */
.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: var(--transition-short);
  transition-timing-function: var(--transition-ease);
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
/* purgecss end ignore */
</style>
